<template>
	<div class="housing mh-700">
		<v-layout row wrap>
			<v-flex xs12>
				<ViewHeader
					src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Ftower-rocks-h600.jpg?alt=media&token=c959321f-457e-4c93-a46d-5cdaf86f9c54"
					title="Housing"
				/>
			</v-flex>

			<v-flex xs12>
				<div class="padded">
					<h3 class="py-3">The La Fonda on the Plaza Hotel</h3>
					<p class="callout">
						We are excited to be hosting the ICBEM at the La Fonda
						on the Plaza hotel, a classical hotel located in Santa
						Fe, New Mexico.
					</p>
					<a
						class="cta"
						href="https://www.lafondasantafe.com/"
						target="_blank"
						>Learn more about the La Fonda</a
					>
					<div class="tourism-links">
						<p></p>
						<div class="info-section-header">
							<font-awesome-icon
								:icon="['fal', 'hotel']"
								class="venue-icon"
							/>
							<h3>Room reservations</h3>
						</div>
						<p>
							Registrants can secure their reservations with La
							Fonda guaranteed by credit card or other means
							specified by the hotel as described in the
							<a class="normal-link" href="/registration-info"
								>registration</a
							>
							tab on this site (no deposit is required). Room
							share for trainees is available. Further information
							regarding room reservations can be found on your
							user profile page once your user account has been
							created. You can create your user account (or log in
							to your account)
							<a class="normal-link" href="/login">here</a>.
						</p>
						<p>
							ICBEM 2022 contract room base rates are $179.00 plus
							local taxes at a total estimated cost of
							$206.63/night. Taxes may be subject to change and
							would affect the final booking rate. Conference room
							rates are valid for 3 days before and 3 days after
							the meeting based on availability.
						</p>
					</div>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
import ViewHeader from '@/components/ViewHeader.vue';
export default {
	name: 'Venue',
	data() {
		return {
			publicPath: process.env.BASE_URL
		};
	},
	components: {
		ViewHeader
	}
};
</script>
<style src="../style.css"></style>
